<div class="flex h-screen dark:bg-white dark:text-black">
  <div class="w-1/2 bg-white">
    <img ngSrc="asset/login.png" width="100" height="100" class="w-full h-full rounded-2xl p-[1%]" alt="login-logo">
  </div>

  <div class="w-1/2 bg-white flex items-center justify-center relative">
    @if (!showOTPScreen) {
    <p-toast></p-toast>
    <a class="flex absolute top-0 left-10 p-4 cursor-pointer gap-4" href="https://www.cotopaxi.com.ec/">
      <div>
        <fa-icon [icon]="faArrowLeft" class="text-xl"></fa-icon>
      </div>
      <div class="flex items-center">
        <span class="font-bold">Regresar a la web</span>
      </div>
    </a>
    <div class="flex flex-col w-3/4">
      <div class="mb-6">
        <h1 class="text-4xl font-bold">Ingresa a tu cuenta</h1>
      </div>

      <div class="flex flex-col gap-8">
        <div class="flex flex-col gap-4">
          <div>
            <label for="email" class="text-gray-500">Correo electrónico</label>
            <input id="email" [(ngModel)]="email" (blur)="email = email?.trim() || null"
              (keyup.enter)="!loading && email ? login() : null" placeholder="Ingresar"
              class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400" />
          </div>
          <button (click)="login()" [disabled]="loading || !email" [ngClass]="getButtonClasses()"
            class="w-full py-4 rounded-2xl flex items-center justify-center space-x-2">
            <span>Solicitar código</span>
          </button>
        </div>
      </div>
    </div>
    } @else if (showOTPScreen && !isCodeVerificationCorrect) {
    <a class="flex absolute top-0 left-10 p-4 cursor-pointer gap-4" (click)="goBack()">
      <div>
        <fa-icon [icon]="faArrowLeft" class="text-xl"></fa-icon>
      </div>
      <div class="flex items-center">
        <span class="font-bold">Volver</span>
      </div>
    </a>
    <p-toast></p-toast>
    <div class="flex flex-col w-3/4">
      <div class="mb-6">
        <h1 class="text-4xl font-bold">Código de verificación</h1>
        <span> Ingresa el código de verificación que hemos enviado a tu correo electrónico. </span>
      </div>

      <div>
        <label for="otp" class="text-gray-500">Código de verificación</label>
        <p-input-otp id="otp" [(ngModel)]="otp" [integerOnly]="true" [length]='6' size="large" [invalid]="isOTPInvalid"
          (ngModelChange)="validateOTPCode()" [disabled]="loading" class="w-full rounded-2xl" />
        @if (isOTPInvalid) {
        <fa-icon [icon]="faTriangleExclamation" class="text-red-600"></fa-icon>
        <span class="text-red-600">Código incorrecto. Intenta de nuevo.</span>
        }
        <div class="mt-5">
          <div class="flex flex-col">
            <div class="flex justify-center">
              <span class="text-gray-500">¿No recibiste el código?</span>
            </div>
            @if (showCountdown) {
            <div class="flex justify-center">
              <p><a class="text-purple-800 underline">Puedes solicitar uno nuevo en
                  <countdown [config]="countdownConfig" (event)="onCountdown($event)"></countdown>
                </a></p>
            </div>
            } @else {
            <p-toast></p-toast>
            <div class="flex justify-center cursor-pointer">
              <p class="text-purple-800 underline" (click)="login(true)">Reenviar código</p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    } @else if (isCodeVerificationCorrect) {
    <div class="flex flex-col w-3/4 -mt-30 items-center">
      <div class="mb-6 flex justify-center">
        <h1 class="text-4xl font-bold text-center">Código de verificación exitoso</h1>
      </div>

      <div class="bg-green-100 text-green-400 w-16 h-16 rounded-full flex items-center justify-center">
        <fa-icon [icon]="faCheckCircle" class="text-green-500 text-3xl"></fa-icon>
      </div>
    </div>
    }
    <div class="absolute bottom-6 right-10 text-[10px] tracking-[0.4em] uppercase text-gray-400">
      {{ versionLabel$ | async }}
    </div>
  </div>
</div>
